import firebase from 'firebase/app'
import 'firebase/firestore'
import axios from 'axios'
import devMode from '@/devMode.js'
import logScope from 'log-scope'
import store from '@/store/store.js'

const log = logScope('dataLog')

const baseURL = 'https://europe-west1-rideq-data.cloudfunctions.net'
let firestore

const dataLog = {
  isInitialized: false,
  firestore: null,
  latestFetches: {},
  fetchLimit: 1000 * 60 * 60 * 1, // 1h
  url: baseURL,
  instance: axios.create({
    baseURL: baseURL,
    headers: {}
  }),
  post: (route, body) => dataLog.instance.post(route, body),
  get: (route, body) => dataLog.instance.get(route, body)
}

dataLog.init = async () => {
  if (dataLog.isInitialized === true) {
    log.warning('Datalog is already initialized')
    return
  } else if (window.k$.isLoggedIn !== true) {
    log.warning('Not logged in')
    return
  }
  dataLog.isInitialized = true

  const config = {
    apiKey: 'AIzaSyD6BuUKmilyhuVTHMRJ- 4hga1r5i3s53cM',
    projectId: 'rideq-data',
    databaseURL: 'https://rideq-data.firebaseio.com'
  }
  const secondary = firebase.initializeApp(config, 'secondary')
  firestore = dataLog.firestore = secondary.firestore()

  log.success('Initialized')
}

dataLog.getSalesFunnel = async () => {
  if (!dataLog.isAllowedToFetch('salesFunnel')) {
    return
  }

  const snapshots = await firestore
    .collection('salesFunnel')
    .where('timestamp', '>', +(new Date()) - 1000 * 60 * 60 * 24 * 7)
    .get()

  const latestData = snapshots.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))

  store.commit('salesFunnel', latestData)
}

dataLog.getLatest = async () => {
  if (!dataLog.isAllowedToFetch('latest')) {
    return
  }

  const snapshot = await firestore.collection('latest')
    // .where('status', '==', 'success') // NOTE: This needs to index the firestore database
    .orderBy('timestamp', 'desc')
    .limit(20)
    .get()

  const data = snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
  }))

  store.commit('latest', data)
}

dataLog.getSetupLog = async () => {
  if (!dataLog.isAllowedToFetch('setupLog')) {
    return
  }

  const snapshot = await firestore.collection('setupLog')
    .orderBy('timestamp', 'desc')
    .limit(20)
    .get()

  const data = snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
  }))

  store.commit('setupLog', data)
}

dataLog.getNewConnection = async () => {
  if (!dataLog.isAllowedToFetch('newConnection')) {
    log.danger('Use existing newConnection')
    return store.getters.newConnection
  }

  const snapshot = await firestore.collection('newConnection')
    // .where('timestamp', '>', +new Date(2019, 5, 15))
    .get()

  const data = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))

  store.commit('newConnection', data)

  return data
}

dataLog.getOnboarding = async () => {
  if (!dataLog.isAllowedToFetch('onboarding')) {
    log.danger('Use existing onboarding')
    return store.getters.onboarding
  }

  const onboardingStartTime = +(new Date()) - 1000 * 60 * 60 * 24 * 14

  const snapshots = await firestore.collection('onboarding')
    .where('timestamp', '>', onboardingStartTime)
    .get()

  const data = snapshots.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
  }))

  store.commit('onboarding', data)
  return data
}

dataLog.getUsers = async () => {
  if (!dataLog.isAllowedToFetch('users')) {
    log.danger('Use existing users')
    return store.getters.users
  }

  const snapshots = await firestore.collection('users').get()
  const data = snapshots.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
  }))

  store.commit('users', data)
  return data
}

dataLog.getRides = async () => {
  if (!dataLog.isAllowedToFetch('rides')) {
    log.danger('Use existing rides')
    return store.getters.rides
  }

  // const onboardingStartTime = +(new Date()) - 1000 * 60 * 60 * 24 * 14

  const snapshot = await dataLog.firestore.collection('rides')
    // .where('timestamp', '>', onboardingStartTime)
    .where('header.nr_of_records', '>', 10)
    .limit(50)
    .get()

  const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))

  log.debug('Rides', data)

  store.commit('rides', data)
  return data
}

dataLog.customLog = (data) => {
  return dataLog.post('customLog', data)
}

dataLog.latest = data => {
  if (window.k$.isLoggedIn === true && devMode.logAdminUsers !== true) {
    return
  }

  const abTestCode = store.getters.abTestCode
  const bodyData = {
    collection: 'latest',
    ...data
  }

  if (abTestCode) {
    bodyData.abTestCode = abTestCode
  }

  return dataLog.post('customLog', bodyData)
}

dataLog.adminLogLatest = data => {
  return dataLog.post('customLog', {
    collection: 'latest',
    ...data
  })
}

dataLog.salesFunnel = data => {
  const abTestCode = store.getters.abTestCode
  const bodyData = {
    ...data
  }

  if (abTestCode) {
    bodyData.abTestCode = abTestCode
  }

  return dataLog.post('salesFunnel', bodyData)
}

dataLog.salesFunnelStep = data => {
  const abTestCode = store.getters.abTestCode
  const bodyData = {
    ...data
  }

  if (abTestCode) {
    bodyData.abTestCode = abTestCode
  }

  return dataLog.post('salesFunnelStep', bodyData)
}

// Helpers
dataLog.isAllowedToFetch = (type) => {
  const now = +new Date()
  const latestFetch = dataLog.latestFetches[type] || 0

  if (now - latestFetch < dataLog.fetchLimit) {
    return false
  }

  dataLog.latestFetches[type] = now
  return true
}

if (devMode.globalShortcuts === true) {
  log.danger('Globalizing')
  window.dataLog = dataLog
}

export default dataLog
